(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyRmbgService', customilyRmbgService);

    function customilyRmbgService(
        blockUI,
        CustomilyRmbgAPIService,
        MultipleFileUploadService,
        $window,
        $mdDialog,
        $timeout
    ) {
        async function applyFilter(object = null, $scope, canvas) {
            const { imageSelected } = $scope;
            const targetObject = object ? object : imageSelected;

            if (targetObject.imageFile) {
                const blockUIMessage = 'Cutting Background ✂️';
                blockUI.start(blockUIMessage);

                try {
                    const response = await CustomilyRmbgAPIService.removeBG(targetObject.imageFile);
                    targetObject.oldRBCustImageFile = targetObject.imageFile;
                    targetObject.imageFile = response;
                    await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);
                    console.log('done rendering image in placeholder, removing block UI');
                } catch (error) {
                    $window.rumReportError(error);
                    targetObject.oldRBCustImageFile = null;
                    $timeout(() => $scope.$apply());
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Background removal error' + (error.statusText ? ': ' + error.statusText : '!'))
                            .textContent(
                                'There seems to be an error with our background removal. Please contact our support team'
                            )
                            .ok('OK!')
                    );
                } finally {
                    $scope.$apply(() => blockUI.stop());
                }
            }
        }

        return {
            applyFilter: applyFilter
        };
    }
})();
